<p-stepper [value]="1" [linear]="true" (valueChange)="stepChange($event)">
  <p-step-list>
    <p-step [value]="1">{{ "restaurant.select_restaurant" | translate }}</p-step>
    <p-step [value]="2">{{ "new_booking.travellers" | translate }}</p-step>
    <p-step [value]="3">{{ "new_booking.date_selection" | translate }}</p-step>
  </p-step-list>
  <p-step-panels>
    <p-step-panel [value]="1">
      <ng-template pTemplate="content" let-activateCallback="activateCallback">
        <div class="reservation-form">
          <div class="fieldset">
            <label for="Restaurants">{{
              "restaurant.select_restaurant" | translate
            }}</label>
            <p-select
              [(ngModel)]="selectedRestaurant"
              [options]="restaurants"
              [style]="{ width: '100%' }"
              optionLabel="name"
              placeholder="{{ 'restaurant.select_restaurant' | translate }}"
              [filter]="true"
            />
          </div>
          <div class="fieldset">
            <label for="date">{{
              "new_booking.date_selection" | translate
            }}</label>
            <p-datepicker
              [iconDisplay]="'input'"
              [showIcon]="true"
              [style]="{ width: '100%' }"
              inputId="date"
              [(ngModel)]="selectedDate"
              [inline]="true"
              [minDate]="minDate"
              [firstDayOfWeek]="1"
              selectOtherMonths="true"
            />
          </div>
        </div>
        <div class="buttons stepper" style="justify-content: flex-end">
          <p-button
            [disabled]="!selectedDate || !selectedRestaurant"
            (onClick)="activateCallback(2)"
            icon="pi pi-arrow-right"
            iconPos="right"
          />
        </div>
      </ng-template>
    </p-step-panel>
    <p-step-panel [value]="2">
      <ng-template pTemplate="content" let-activateCallback="activateCallback">
        <div class="reservation-form">
          <div>
            <label>{{ "new_booking.travellers" | translate }}</label>
            <app-passenger-selection
              [multiSelect]="true"
              [passengers]="passengerList"
              [(selectedPassengers)]="selectedPassengers"
            >
            </app-passenger-selection>
          </div>

          <div class="fieldset">
            <label for="notes">{{ "new_booking.notes" | translate }}</label>
            <textarea
              id="notes"
              [autoResize]="true"
              cols="30"
              pTextarea
              rows="5"
              [(ngModel)]="notes"
            >
            </textarea>
          </div>
        </div>
        <div class="buttons stepper">
          <p-button (onClick)="activateCallback(1)" icon="pi pi-arrow-left" />

          <p-button
            [disabled]="!selectedPassengers || selectedPassengers.length === 0"
            (onClick)="activateCallback(3)"
            icon="pi pi-arrow-right"
          />
        </div>
      </ng-template>
    </p-step-panel>
    <p-step-panel [value]="3">
      <ng-template pTemplate="content" let-activateCallback="activateCallback">
        <div>
          <app-table-card
            [reservedTableId]="reservedTableId"
            [date]="selectedDate"
            [restaurant]="selectedRestaurant"
            [(selectedTable)]="selectedTable"
          />
        </div>
        <div class="buttons stepper">
          <p-button (onClick)="activateCallback(2)" icon="pi pi-arrow-left" />
          @if (edit){
          <p-button
            (onClick)="updateReservation()"
            label="{{ 'edit' | translate }}"
          />
          } @else {
          <p-button
            (onClick)="createReservation()"
            label="{{ 'create' | translate }}"
            [disabled]="selectedTable == null"
          />
          }
        </div>
      </ng-template>
    </p-step-panel>
  </p-step-panels>
</p-stepper>
